import { ImportProductImagesResponse, ProductImageList, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/catalog/products/:id/images` — as fotos.
 *
 * Os bytes sobem como bytes, em multipart. Base64 dentro de JSON os inflaria
 * em um terço e obrigaria o arquivo inteiro a existir como string antes.
 */
export const fetchProductImages = async (productId, signal) => ProductImageList.parse(await request(`/api/v1/catalog/products/${productId}/images`, { signal }));
/**
 * Uploads one photograph.
 *
 * Multipart, so the bytes go up as bytes. Base64 in JSON would inflate them by
 * a third and force the whole file to exist as a string first.
 */
export const uploadProductImage = async (productId, file) => {
    const form = new FormData();
    form.append('file', file);
    return ProductImageList.parse(await request(`/api/v1/catalog/products/${productId}/images`, {
        method: 'POST',
        body: form,
    }));
};
/**
 * As fotos de um catálogo inteiro, num ZIP nomeado pelos códigos.
 *
 * Sem `Content-Type` explícito, como todo envio de arquivo aqui: quem monta o
 * cabeçalho com a fronteira do multipart é o `FormData`, e escrevê-lo à mão
 * produz um corpo que o servidor não consegue separar.
 */
export const importProductImages = async (file) => {
    const form = new FormData();
    form.append('file', file);
    return ImportProductImagesResponse.parse(await request('/api/v1/catalog/images/import', {
        method: 'POST',
        body: form,
    }));
};
export const updateProductImage = async (productId, imageId, input) => ProductImageList.parse(await request(`/api/v1/catalog/products/${productId}/images/${imageId}`, {
    method: 'PATCH',
    body: input,
}));
export const reorderProductImages = async (productId, imageIds) => ProductImageList.parse(await request(`/api/v1/catalog/products/${productId}/images/order`, {
    method: 'POST',
    body: { imageIds },
}));
export const deleteProductImage = async (productId, imageId) => ProductImageList.parse(await request(`/api/v1/catalog/products/${productId}/images/${imageId}`, {
    method: 'DELETE',
}));
//# sourceMappingURL=catalog-images.js.map